import { useQuery, useQueryClient } from 'react-query';
import EmailAddress from 'services/data/email-address';
import Person from 'services/data/person';
import useReduxSelector from './useReduxSelector';

export const CURRENT_USER_KEY = 'currentUser';

/**
 * Returns the logged-in Person, fetched via react-query rather than the legacy
 * flux flow in app.js. The user's identity (email) still comes from the auth
 * slice of the redux store until auth itself is modernized.
 *
 * @param {object} queryOptions - forwarded to react-query's useQuery.
 * @returns the useQuery result plus a convenience `currentUser` alias for `data`.
 */
export default function useCurrentUser(queryOptions = {}) {
  const email = useReduxSelector((state) => state.auth.profile.email);
  const key = [CURRENT_USER_KEY, email];

  const queryClient = useQueryClient();
  const queryData = useQuery(
    key,
    () => EmailAddress
      .find({ where: { email: { ilike: email } }, load: ['contact.team'] })
      .then((foundEmails) => new Person(foundEmails[0].contact)),
    { enabled: !!email, ...queryOptions }
  );

  return {
    ...queryData,
    currentUser: queryData.data,
    refetch: () => queryClient.refetchQueries(key)
  };
}
